module.exports = __webpack_public_path__ + "static/media/angular.48ae79d9.svg";